<form [formGroup]="form" class="form-horizontal">
    <div class="form-group">
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <label for="completionDeadline" class="form-control-label">
                        Prazo de Conclusão
                    </label>
                    <input type="text" id="completionDeadline" class="form-control" placeholder="72"
                        formControlName="completionDeadline" />
                </div>
            </div>
            <div class="col-md-8">
                <div class="form-group">
                    <label for="bankNumbers" class="form-control-label">Bancos</label>
                    <ng-select [items]="bankOptions" [multiple]="true" [closeOnSelect]="false" [addTag]="addBank"
                        bindLabel="label" formControlName="bankNumbers" placeholder="Selecione os Bancos">
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div *ngIf="items.length <= 3" class="ng-values-list">
                                <div class="ng-value" *ngFor="let item of items | slice : 0 : 3">
                                    <span class="ng-value-label">{{item.label}}</span>
                                    <span (click)="clear(item)" class="ng-clear">×</span>
                                </div>
                            </div>
                            <div *ngIf="items.length > 3" class="ng-summary-list">
                                <div class="ng-value">
                                    <span class="ng-value-label">{{ items.length }} Selecionados</span>
                                </div>
                            </div>
                        </ng-template>

                        <ng-option *ngFor="let option of bankOptions" [value]="option">
                            {{ option.label }}
                        </ng-option>
                    </ng-select>
                </div>
            </div>

            <!--upload dos arquivos, atenção-->
            <div class="col-md-4 col-12">
                <app-upload-file-input [form]="form" controlName="instructionsPDF" label="PDF de Instruções (Admissão)"
                    tooltipTitle="Requisitos do Arquivo" tooltipText="Permitido apenas PDF, com tamanho máximo de 10Mb."
                    [allowedExtensions]="['pdf']" [maxSizeMb]="10"
                    (fileUploaded)="onFileUploaded($event)"></app-upload-file-input>
            </div>
            <div class="col-md-4 col-12">
                <ng-container *ngTemplateOutlet="uploadInputFileVideo"></ng-container>
            </div>
            <div class="col-md-4 col-12">
                <app-upload-file-input [form]="form" controlName="benefitsPDF" label="PDF de Benefícios (Admissão)"
                    tooltipTitle="Requisitos do Arquivo" tooltipText="Permitido apenas PDF, com tamanho máximo de 10Mb."
                    [allowedExtensions]="['pdf']" [maxSizeMb]="10"
                    (fileUploaded)="onFileUploaded($event)"></app-upload-file-input>
            </div>

        </div>
        <div class="form-group">
            <div class="divider divider-primary">
                <div class="divider-text">NOTIFICAÇÕES DO CANDIDATO</div>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-md-12">
                <div class="custom-control custom-switch custom-switch-primary">
                    <input type="checkbox" id="notifyCandidates" class="custom-control-input"
                        formControlName="notifyCandidates" />
                    <label class="custom-control-label" for="notifyCandidates">
                        Ativar notificações para candidatos
                    </label>
                </div>
                <small class="text-muted">
                    Quando desativado, o candidato não receberá mensagens de admissão (WhatsApp e e-mail).
                </small>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-md-12" *ngIf="initialConfigs.hasOfferLetterStage">
                <div class="form-group">
                    <label for="offerLetterMessage" class="form-control-label">
                        Mensagem da Carta Proposta
                    </label>
                    <input type="text" id="offerLetterMessage" class="form-control"
                        placeholder="RHGESTAO: Olá, tudo bem? A sua proposta para o cargo de {jobTitleName} já está disponível! Você pode visualizá-la e tomar uma decisão clicando no link abaixo: {Frontend_URL}/{Domain}/frmadm/{00000000000}Caso prefira apenas visualizá-la, clique neste link: {offerLetterDoc}"
                        formControlName="offerLetterMessage" />
                </div>
            </div>
            <div class="col-md-12" *ngIf="initialConfigs.hasOfferLetterStage">
                <div class="form-group">
                    <label for="offerLetterEmail" class="form-control-label">Descrição do E-mail da Carta
                        Proposta</label>
                    <input type="text" id="offerLetterEmail" class="form-control"
                        placeholder="RHGESTAO: Olá, tudo bem? A sua proposta para o cargo de {jobTitleName} já está disponível! Você pode visualizá-la e tomar uma decisão clicando no link abaixo. Caso prefira apenas visualizá-la, abra o documento que está em anexo."
                        formControlName="offerLetterEmail" />
                </div>
            </div>
            <div class="col-md-12" *ngIf="initialConfigs.hasAdmissionExams">
                <div class="form-group">
                    <label for="asoExamMessage" class="form-control-label">Mensagem de Solicitação de Exames</label>
                    <input type="text" id="asoExamMessage" class="form-control"
                        placeholder="RHGESTAO: Olá, {applicantName}! Para dar continuidade ao processo, acesse o link abaixo e realize os exames necessários.{publicUrl}"
                        formControlName="asoExamMessage" />
                </div>
            </div>
            <div class="col-md-8 col-12">
                <div class="form-group">
                    <label for="wppCongratsMessage" class="form-control-label">Mensagem Inicial de Admissão</label>
                    <input type="text" id="wppCongratsMessage" class="form-control"
                        placeholder="RHGESTAO: Parabéns, você foi aprovado para a vaga {jobTitleName}. Clique no link, preencha seus dados e envie sua documentação. {Frontend_URL}/{Domain}/frmadm/{00000000000}"
                        formControlName="wppCongratsMessage" />
                </div>
            </div>
            <div class="col-md-4 col-12">
                <app-upload-file-input [form]="form" controlName="wppCoverImageFile"
                    label="Imagem de Admissão" tooltipTitle="Requisitos do Arquivo"
                    tooltipText="Permitido apenas imagens nos formatos: 'PNG', 'JPGE', 'JPG' ou 'JFIF', com tamanho máximo de 10Mb."
                    [allowedExtensions]="['png', 'jpeg', 'jpg', 'jfif']" [maxSizeMb]="10"
                    (fileUploaded)="onFileUploaded($event)"></app-upload-file-input>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <label for="wppInvalidDocsMessage" class="form-control-label">Mensagem de Documentação
                        Inválida</label>
                    <input type="text" id="wppInvalidDocsMessage" class="form-control"
                        placeholder="RHGESTAO: Alguns documentos foram rejeitados, por favor acesse o portal para corrigir: {Frontend_URL}/{Domain}/frmadm/{00000000000}"
                        formControlName="wppInvalidDocsMessage" />
                </div>
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label for="wppFinishedMessage" class="form-control-label">Mensagem Conclusão</label>
                    <input type="text" id="wppFinishedMessage" class="form-control"
                        placeholder="RHGESTAO: Temos a satisfação de confirmar sua contratação para posição de {jobTitleName}. Sua data de início conosco será {dateStart}"
                        formControlName="wppFinishedMessage" />
                </div>
            </div>
        </div>
    </div>

    <div class="form-group">
        <div class="divider divider-primary">
            <div class="divider-text">NOTIFICAÇÕES SESMT E DP</div>
        </div>
    </div>
    <div class="form-group">
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label>E-mail - Notificações SESMT</label>
                    <ng-select [items]="sesmtEmailOptions" [multiple]="true" [closeOnSelect]="false" [addTag]="addEmail"
                        bindLabel="label" formControlName="sesmtAlertEmail" placeholder="Selecione os emails">
                        <ng-option *ngFor="let option of sesmtEmailOptions" [value]="option.value">
                            {{ option.label }}
                        </ng-option>
                    </ng-select>
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <label>E-mail - Notificações DP</label>
                    <ng-select [multiple]="true" [closeOnSelect]="false" [addTag]="addEmail" [searchable]="true"
                        formControlName="dpAlertEmail" placeholder="Selecione os emails">
                        <ng-option *ngFor="let option of dpEmailOptions" [value]="option.value">
                            {{ option.label }}
                        </ng-option>
                    </ng-select>
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <label>E-mail - Notificações Finalização</label>
                    <ng-select [multiple]="true" [closeOnSelect]="false" [addTag]="addEmail" [searchable]="true"
                        formControlName="finishedAlertEmail" placeholder="Selecione os emails">
                        <ng-option *ngFor="let option of finishedEmailOptions" [value]="option.value">
                            {{ option.label }}
                        </ng-option>
                    </ng-select>
                </div>
            </div>
        </div>
    </div>

    <div class="form-group">
        <div class="divider divider-primary">
            <div class="divider-text">CONFIGURAÇÃO DE CAMPOS</div>
        </div>

        <p class="text-muted mt-2">
            Os campos do formulário de admissão e do candidato afetam diretamente o fluxo do processo.
        </p>

        <button class="btn btn-outline-primary" (click)="confirmOpenAdmissionFields()">
            <i data-feather="settings" class="mr-1"></i>
            Configurar Campos dos Formulários
        </button>
    </div>

    <ng-container *ngIf="initialConfigs?.usesOCR">
        <div class="form-group">
            <div class="divider divider-primary">
                <div class="divider-text">OCR</div>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-md-12">
                <div class="custom-control custom-switch custom-switch-primary">
                    <input type="checkbox" id="validateImageQuality" class="custom-control-input"
                        formControlName="validateImageQuality" />
                    <label class="custom-control-label" for="validateImageQuality">
                        Validar qualidade da imagem
                    </label>
                </div>
                <small class="text-muted">
                    Quando desativado, documentos enviados no OCR não passarão pela validação de qualidade da imagem.
                </small>
            </div>
        </div>
    </ng-container>

    <app-shared-drawer [title]="drawerTitle" className="drawer-hiring-config-form"
        contentClassName="drawer-hiring-config-form" [isOpen]="drawerState" (onClose)="drawerState = false">
        <div class="accordion-no-min">
            <section id="accordion">
                <div class="row">
                    <div class="col-sm-12">
                        <div id="accordionWrapa1" role="tablist" aria-multiselectable="true">
                            <div class="card-body collapse-icon">
                                <div class="divider divider-primary">
                                    <div class="divider-text">CAMPOS - ADMISSÃO</div>
                                </div>
                                <ngb-accordion [destroyOnHide]="false" [closeOthers]="true" activeIds="panel1">
                                    <ngb-panel id="panel1">
                                        <ng-template ngbPanelTitle let-opened="opened">
                                            <div class="d-flex align-items-center cursor-pointer">
                                                <span class="text-edit font-weight-bold">
                                                    Selecione abaixo os campos obrigatórios para o processo de admissão:
                                                </span>
                                            </div>
                                        </ng-template>

                                        <ng-template ngbPanelContent>
                                            <div [formGroup]="form.get('setAdmissionForm')">
                                                <div class="form-group">
                                                    <div class="row mb-2" *ngFor="let field of admissionMetadata">
                                                        <div class="col-md-6 d-flex align-items-center">
                                                            <label *ngIf="!field.info" class="font-weight-bold">{{
                                                                field.label }}</label>
                                                            <label *ngIf="field.info"
                                                                class="font-weight-bold cursor-pointer"
                                                                popoverTitle="Informativo" [ngbPopover]="field.info"
                                                                triggers="mouseenter:mouseleave" placement="right">
                                                                {{ field.label }}
                                                                <span [data-feather]="'info'"
                                                                    class="cursor-pointer text-primary"></span>
                                                            </label>
                                                        </div>

                                                        <div class="col-md-6 d-flex align-items-center">
                                                            <label class="mr-3">
                                                                <input type="radio"
                                                                    [attr.name]="'admission_' + field.key"
                                                                    formControlName="{{field.key}}" [value]="1" />
                                                                Obrigatório
                                                            </label>
                                                            <label class="mr-3">
                                                                <input type="radio"
                                                                    [attr.name]="'admission_' + field.key"
                                                                    formControlName="{{field.key}}" [value]="2" />
                                                                Opcional
                                                            </label>
                                                            <label>
                                                                <input type="radio"
                                                                    [attr.name]="'admission_' + field.key"
                                                                    formControlName="{{field.key}}" [value]="3" />
                                                                Não visível
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </ngb-panel>
                                </ngb-accordion>

                                <div class="form-group mt-3">
                                    <div class="divider divider-primary">
                                        <div class="divider-text">CAMPOS - CANDIDATO (FORMULÁRIO INICIAL)</div>
                                    </div>
                                </div>

                                <ngb-accordion [destroyOnHide]="false" [closeOthers]="true" activeIds="panel2">
                                    <ngb-panel id="panel2">
                                        <ng-template ngbPanelTitle let-opened="opened">
                                            <div class="d-flex align-items-center cursor-pointer">
                                                <span class="text-edit font-weight-bold">
                                                    Selecione abaixo os campos obrigatórios para o processo de
                                                    candidato:
                                                </span>
                                            </div>
                                        </ng-template>

                                        <ng-template ngbPanelContent>
                                            <div [formGroup]="form.get('setApplicantForm')">
                                                <div class="form-group">
                                                    <div class="row mb-2" *ngFor="let field of applicantMetadata">
                                                        <div class="col-md-6 d-flex align-items-center">
                                                            <label *ngIf="!field.info" class="font-weight-bold">{{
                                                                field.label }}</label>
                                                            <label *ngIf="field.info"
                                                                class="font-weight-bold cursor-pointer"
                                                                popoverTitle="Informativo" [ngbPopover]="field.info"
                                                                triggers="mouseenter:mouseleave" placement="right">
                                                                {{ field.label }}
                                                                <span [data-feather]="'info'"
                                                                    class="cursor-pointer text-primary"></span>
                                                            </label>
                                                        </div>

                                                        <div class="col-md-6 d-flex align-items-center">
                                                            <label class="mr-3">
                                                                <input type="radio"
                                                                    [attr.name]="'applicant_' + field.key"
                                                                    formControlName="{{field.key}}" [value]="1" />
                                                                Obrigatório
                                                            </label>
                                                            <label class="mr-3">
                                                                <input type="radio"
                                                                    [attr.name]="'applicant_' + field.key"
                                                                    formControlName="{{field.key}}" [value]="2" />
                                                                Opcional
                                                            </label>
                                                            <label>
                                                                <input type="radio"
                                                                    [attr.name]="'applicant_' + field.key"
                                                                    formControlName="{{field.key}}" [value]="3" />
                                                                Não visível
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </ngb-panel>
                                </ngb-accordion>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div class="drawer-footer">
                <button class="btn btn-primary" (click)="drawerState = false">
                    Continuar Configurações
                </button>
            </div>
        </div>
    </app-shared-drawer>
</form>

<ng-template #uploadInputFileVideo>
    <div class="d-flex justify-content-between">
        <label class="form-control-label cursor-pointer" popoverTitle="Requisitos do Arquivo"
            ngbPopover="Permitido apenas arquivos nos formatos: 'MP4', 'MOV', 'AVI', com tamanho máximo de 50Mb."
            triggers="mouseenter:mouseleave">
            <span [data-feather]="'info'"></span>
            Vídeo de Boas-Vindas (Admissão)
        </label>

        <a *ngIf="instructionsMp4Url" [href]="instructionsMP4" target="_blank" class="link-primary">
            Visualizar
        </a>
    </div>

    <div class="custom-file">
        <input id="lessonFileInput" type="file" class="custom-file-input" accept="video/mp4,video/avi,video/mov"
            (change)="onLessonFileSelected($event, 'organization')" [disabled]="uploadInProgress" />
        <label for="lessonFileInput" class="custom-file-label">
            {{ getInstructionsMp4FileName }}
        </label>

        <div *ngIf="uploadInProgress" class="progress mt-2">
            <div class="progress-bar" role="progressbar" [style.width.%]="uploadProgress"
                [attr.aria-valuenow]="uploadProgress" aria-valuemin="0" aria-valuemax="100">
                {{ uploadProgress }}%
            </div>
        </div>
    </div>
</ng-template>